// src/components/SessionExpiredModal.js
import React from "react";
import { Modal, Button } from "antd";

const SessionExpiredModal = ({ visible, onOk }) => {
  return (
    <Modal
      title="Session Expired"
      open={visible}
      footer={[
        <Button key="ok" type="primary" onClick={onOk}>
          OK
        </Button>,
      ]}
      closable={false}
      centered
    >
      <p>Your session has expired. Please log in again.</p>
    </Modal>
  );
};

export default SessionExpiredModal;
